<template>
  <div
    class="modal fade"
    :class="{ show: showTimeBlockModal }"
    :style="{ display: showTimeBlockModal ? 'block' : 'none' }"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-xl"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">{{ $t('global.appointmentDetails') }}</h4>
        </div>
        <div class="modal-body">
          <table class="table">
            <thead>
              <tr>
                <th>Bezeichnung</th>
                <th>Datum</th>
                <th>Zeit</th>
                <th>Dozenten</th>
                <th>Räume</th>
                <th>Details Dozierende</th>
                <th>Details Schüler</th>
              </tr>
            </thead>
            <tbody style="word-break: break-word">
              <td>{{ activeTimeBlockWithFK?.bezeichnung }}</td>
              <td>{{ activeTimeBlockWithFK?.bis }}</td>
              <td>
                {{ activeTimeBlockWithFK?.von_uhrzeit }} -
                {{ activeTimeBlockWithFK?.bis_uhrzeit }}
              </td>
              <td
                v-if="
                  activeTimeBlockWithFK?.dozenten &&
                  activeTimeBlockWithFK.dozenten.length
                "
              >
                {{
                  activeTimeBlockWithFK.dozenten.map((r) => r.name).join(', ')
                }}
              </td>
              <td v-else>Keine Dozierenden eingeplant</td>
              <td
                v-if="
                  activeTimeBlockWithFK?.raumliste &&
                  activeTimeBlockWithFK.raumliste.length
                "
              >
                {{
                  activeTimeBlockWithFK.raumliste
                    .map((r) => r.bezeichnung)
                    .join(', ')
                }}
              </td>
              <td v-else>Keine Räume gebucht</td>
              <td v-if="activeTimeBlockWithFK?.description_lecturer">
                <span v-html="activeTimeBlockWithFK.description_lecturer" />
              </td>
              <td v-if="activeTimeBlockWithFK?.description_students">
                <span v-html="activeTimeBlockWithFK.description_students" />
              </td>
              <td>
                <div class="entry-actions">
                  <font-awesome-icon
                    :icon="['fas', 'up-right-from-square']"
                    class="action-icon"
                    @click.stop="openTermin"
                  />
                </div>
              </td>
            </tbody>
          </table>
          <hr style="border: 0; border-top: 4px solid red" />
          <table class="table">
            <thead>
              <tr>
                <th>Konflikttermin Name</th>
                <th>Konflikttermin Personen</th>
                <th>Konflikttermin Räume</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(conflict, idx) in activeTimeBlockConflict"
                :key="idx"
              >
                <td>{{ conflict.tooltip }}</td>
                <td>
                  <span v-if="conflict.type === 'People'">
                    {{ conflict.designation }}
                  </span>
                  <span v-else>Keine Dozierendenkonflikte</span>
                </td>
                <td>
                  <span v-if="conflict.type === 'Room'">
                    {{ conflict.designation }}
                  </span>
                  <span v-else>Keine Raumkonflikte</span>
                </td>
                <td>
                  <div class="entry-actions">
                    <font-awesome-icon
                      :icon="['fas', 'up-right-from-square']"
                      class="action-icon"
                      @click.stop="openConflict(conflict.conflictId)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import ModalCloseButton from '@/components/global/ModalCloseButton.vue'

  export default {
    name: 'VisualPlannerModal',
    components: {
      ModalCloseButton,
    },

    computed: {
      ...mapState('FeatureMetadata', ['showTimeBlockModal']),
      ...mapState('VisualPlannerMetadata', ['activeTimeBlockWithFK']),
      ...mapState('VisualPlannerMetadata', ['activeTimeBlockConflict']),
    },
    mounted() {
      window.addEventListener('keydown', this.handleEscClose)
    },

    methods: {
      ...mapActions('FeatureMetadata', ['closeTimeBlockModal']),
      ...mapActions('VisualPlannerMetadata', ['setActiveTerminEntry']),

      openTermin() {
        const routeData = this.$router.resolve({
          name: 'termin',
          params: { id: this.activeTimeBlockWithFK?.id, anzeige: 0 },
        })
        window.open(routeData.href, '_blank')
      },

      handleEscClose(event) {
        if (event.key === 'Escape' && this.showTimeBlockModal) {
          this.closeModal()
        }
      },

      openConflict(conflictId) {
        const routeData = this.$router.resolve({
          name: 'termin',
          params: { id: conflictId, anzeige: 0 },
        })
        window.open(routeData.href, '_blank')
      },

      closeModal() {
        this.setActiveTerminEntry(null)
        this.closeTimeBlockModal()
      },
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.handleEscClose) // Cleanup
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/features/visual_planner/scss/color';
</style>
